// extracted by mini-css-extract-plugin
export default {"checkbox":"FSVSPgXar0yx4cwbF6CQ"};
    if(module.hot) {
      // 1647894321506
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  